/**
 * Словник: fr.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_fr.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ En attente de l’autre participant...",
  connectionLost: "Connexion perdue",
  peerLeft: "👋 L’autre participant a quitté l’appel",
  connectionError: "🚫 Erreur de connexion",
  connectionFailedTryAgain: "🚫 Impossible de se connecter au serveur. Veuillez réessayer.",
  reconnectionFailed: "🚫 Connexion perdue. Impossible de la rétablir après {attempts} tentatives.",
  connectionErrorWithDetails: "🚫 Erreur de connexion : {error}",
  speakerLoud: "Fort",
  speakerEar: "Écouteur",
  copyRoomId: "Copier l’ID de la salle",
  share: "Partager",
  linkCopied: "🔗 Lien copié !",
  idCopied: "🆔 ID copié !",
  startMeeting: "Démarrer une réunion",
  chooseAction: "Choisissez une action",
  createNewRoom: "Nouvelle salle",
  scheduleCall: "Planifier un appel",
  calendarOpened: "📅 Calendrier ouvert",
  linkCopiedToClipboard: "🔗 Lien copié dans le presse-papiers",
  enterRoomId: "ID de la salle",
  roomIdValidationError: "L’ID de la salle ne peut contenir que des lettres, des chiffres et des tirets",
  joinRoom: "REJOINDRE",
  termsAndPrivacyHelp: "Conditions et confidentialité | Aide",
  invite: "Inviter",
  mySettings: "Mes paramètres",
  peerSettings: "Paramètres du correspondant",
  blockRemoteControl: "Bloquer le contrôle à distance",
  iAgreeToTerms: "J’accepte les conditions du service",
  termsOfUse: "Conditions d’utilisation",
  privacyPolicy: "Politique de confidentialité",
  howToUse: "Mode d’emploi",
  termsAcceptanceRequired: "Vous devez accepter les conditions pour utiliser le service",
  ok: "OK",
  permissionsRequired: "Autorisations requises",
  permissionsNeededMessage: "Cette app a besoin des autorisations suivantes pour fonctionner correctement :",
  permissionsNote: "Remarque : lorsque vous modifiez les autorisations dans Réglages, iOS redémarre l’app. C’est un comportement normal.",
  permissionsEnableMessage: "Pour continuer, veuillez activer ces autorisations dans les paramètres de votre appareil.",
  cancel: "Annuler",
  openSettings: "Ouvrir les paramètres",
  websocketError: "Erreur WebSocket",
  roomFull: "La salle est pleine",
  timeExpired: "Temps écoulé",
  remaining: "rest.",
  mediaPermissionsRequired: "Les appels vidéo nécessitent l’accès à la caméra et au micro. Veuillez accorder les autorisations dans votre navigateur.",
  mediaPermissionsRequiredMobile: "Les appels vidéo nécessitent l’accès à la caméra et au micro. Veuillez accorder les autorisations dans les paramètres de l’app.",
  browserSettings: "Paramètres du navigateur",
  openAppSettings: "Ouvrir les paramètres",
  grantPermissions: "Accorder les autorisations",
  permissionsNotGranted: "Autorisations non accordées. Veuillez les accorder pour continuer.",
  permissionRequestError: "Erreur lors de la demande d’autorisations : {error}",
  camera: "Caméra",
  microphone: "Micro",
  cameraDescription: "Pour la transmission vidéo",
  microphoneDescription: "Pour la transmission audio",
  continueWithoutPermissions: "Continuer sans autorisations",
  mediaPermissionsRequiredFallback: "Les appels vidéo nécessitent des autorisations multimédias. Veuillez les accorder dans les paramètres du navigateur.",
  mediaPermissionsRequiredMobileFallback: "Les appels vidéo nécessitent des autorisations multimédias. Veuillez les accorder dans les paramètres de l’app.",
  browserSettingsFallback: "Paramètres du navigateur",
  openAppSettingsFallback: "Ouvrir les paramètres",
  permissionsPermanentlyDenied: "Autorisations refusées définitivement. Veuillez les activer dans les paramètres de l’app.",
  continueText: "Continuer",
  mirror: "Miroir",
  fitContain: "Ajuster",
  fitCover: "Remplir",
  switchCamera: "Basculer",
  block: "Bloquer",
  pip: "PiP",
  mic: "Micro",
  video: "Vidéo",
  speaker: "Haut-parleur",
  readyToConnect: "Prêt à vous connecter ?",
  startOneOnOne: "Lancer un appel vidéo",
  createPrivateLink: "Lien prêt en une seconde",
  welcomeExplainer: "Créez un lien et envoyez-le à qui vous voulez. Il s’ouvre même sans l’app.",
  joinHaveLink: "Vous avez un lien ?",
  joinFieldHint: "Collez un lien ou un ID",
  roomInputInvalid: "Collez un lien d’appel ou l’ID d’une salle (lettres, chiffres et tirets)",
  guestTitle: "On vous invite à un appel vidéo",
  guestBody: "La salle est prête. L’autre personne vous verra dès que vous rejoindrez l’appel.",
  guestJoin: "Rejoindre",
  guestFreeNote: "Rejoindre est toujours gratuit",
  guestCreateOwn: "Créer ma propre salle",
  guestInvalidTitle: "Ce lien semble défectueux",
  guestInvalidBody: "Demandez à nouveau le lien ou créez votre propre salle.",
  inviteCardTitle: "Votre salle est prête",
  inviteCardBody: "Envoyez le lien à la personne avec qui vous voulez parler",
  inviteShareLink: "Partager le lien",
  inviteCopy: "Copier",
  inviteBrowserHint: "S’ouvre dans n’importe quel navigateur. Inutile d’installer l’app.",
  inviteSentHint: "Envoyé ? L’autre personne apparaîtra ici dès qu’elle ouvrira le lien.",
  inviteShareMessage: "Rejoins mon appel vidéo sur One2One 👋\nOuvre simplement le lien. Ça marche dans ton navigateur, rien à installer :\n{link}",
  copyLink: "Copier le lien",
  consentBannerText: "Pouvons-nous collecter des statistiques d’utilisation ? Elles nous indiquent les fonctionnalités utilisées. Le contenu des appels n’y figure jamais.",
  consentAllow: "Autoriser",
  consentDeny: "Ne pas autoriser",
  privacySettingsLink: "Paramètres des statistiques",
} as const;
